export const formatDateToISO = async (date: Date) => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-indexed
  const day = String(date.getDate()).padStart(2, '0'); // Ensure two digits
  return `${year}-${month}-${day}`;
};

export const calculateValidityTo = (
  validityDays: string,
  formattedStartDate: any,
) => {
  const regexResult = validityDays.match(/(\d+)-(\w+)/);

  if (!regexResult || regexResult.length !== 3) {
    return null; // or some default value
  }

  const numericValue = parseInt(regexResult[1], 10);
  const unit = regexResult[2].toLowerCase();

  if (isNaN(numericValue) || numericValue <= 0) {
    return null; // or some default value
  }

  const today = new Date();
  const validityTo = new Date(formattedStartDate);

  switch (unit) {
    case 'day':
    case 'days':
      validityTo.setDate(validityTo.getDate() + numericValue);
      break;
    case 'month':
    case 'months':
      validityTo.setMonth(validityTo.getMonth() + numericValue);
      break;
    case 'year':
    case 'years':
      validityTo.setFullYear(validityTo.getFullYear() + numericValue);
      break;
    default:
      return null; // or some default value
  }

  if (unit === 'months') {
    validityTo.setDate(0); // Set to the last day of the current month
  } else if (unit === 'years') {
    validityTo.setMonth(11); // Set to December
    validityTo.setDate(31); // Set to the last day of December
  }

  return validityTo;
};
